module.exports = function(fn) {
  return function(a, b, c, d, e) {
    return fn.apply(null, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/arity-n/5.js
// module id = ./node_modules/arity-n/5.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons